<template>
<!-- 数据统计 -->
    <div class="analysis-container">
        <el-tabs v-model="activeName" @tab-click="pullData">
            <el-tab-pane v-for="(item,idx) in tabs" :key="idx" :label="item.name" :name="item.name"></el-tab-pane>
        </el-tabs>
        <div class="el-card pd20">
            <div class="main">
                <div class="box">
                    <!--  --> 
                    <div class="search">
                        <div class="search-gropu">
                            时间：
                            <el-date-picker
                              v-model="timerange"
                              type="datetimerange"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
                    </div>
                
                </div>
                <!-- list-->
                <div class="el-card pd20">
                    <el-table :data="list" show-overflow-tooltip border style="width: 100%">
                        <el-table-column prop="name" label="测评类型" > </el-table-column>
                        <el-table-column prop="visit_count" label="页面访问数"></el-table-column>
                        <el-table-column prop="submit_count" label="提交表单数" > </el-table-column>
                        <el-table-column prop="success_count" label="新增用户数" > </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { cepingAnalysis } from "@/api/extension";
export default {
    data() {
        return{
            activeName: '公号',
            tabs: [{
                name: '公号',
                lead_sid: 1,
                cids: [52,73,46,71,47,72,76,55,49,44,82,62,54,58,74,79],
            },{
                name: '外部',
                lead_sid: 0,
                cids: [52,73,46,71,47,72,76,55,49,44,82,62,54,58,74,79],
            },{
                name: '投放',
                lead_sid: 2,
                cids: [71],
            }],
            list: [],
            timerange: null
        }
    },
    methods:{
        pullData(){
            this.$showLoading();

            let activeItem = this.tabs.filter(item=>item.name == this.activeName)[0];

            let obj = {
                cids: activeItem.cids,
                lead_sid: activeItem.lead_sid,
            };

            if(this.timerange && this.timerange[0]) {
                obj.start_time = this.timerange[0];
            }
            if(this.timerange && this.timerange[1]) {
                obj.end_time = this.timerange[1];
            }

            cepingAnalysis(obj).then(data=>{
                this.list = data.list;
                this.$hideLoading();
            });
        },
    },
    mounted() {

    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.analysis-container ::v-deep .el-tabs__nav-scroll {
    background: #fff;
    padding: 2px 20px;
    border-radius: 4px;
}
.analysis-container::v-deep .el-tabs__item::before, .analysis-container::v-deep .el-tabs__item::after {
    content: ' ';
    display: inline-block;
    width: 1.5em;
}
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
.preview{
    width: 300px;
    border-radius: 5px;
}
.box{
    margin-bottom: 20px;
}
.search{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.search.search-btn{
    flex: 1;
}
.search-gropu{
    flex: 1;
}
.search-gropu.on{
    flex: 1.5;
}
.search-child{
    margin-left: 20px;
    width: 200px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
.el-input{
    width:200px;
}
</style>